export default {
  state: {
    defaultData: {},
  },

  getters: {
    getProceduresData(state) {
      return state.defaultData;
    },
  },

  mutations: {
    setProceduresData(state, data) {
      const isNull = data === null;

      state.defaultData = {
        id: !isNull ? data.id : "",
        name: !isNull ? data.name : "",
      };
    },
  },

  actions: {
    changeProceduresData(context, infos) {
      context.commit("setProceduresData", infos);
    },
  },
};
